export default "__VITE_ASSET__E2I5W_fe__"